import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import Style from '../../styles/common';
import { TIER } from './constants';

const Container = styled('div')`
  cursor: default;
  display: inline-block;
`;

const StyledTextButton = styled('a')`
  align-items: center;
  color: ${props => props.tier === TIER.PRIMARY ? Style.color.BTN_NEUTRAL : Style.color.BTN_TEXT_SECONDARY};
  display: flex;
  height: ${Style.MEASUREMENT.BUTTON.HEIGHT};
  justify-content: center;
  min-width: ${Style.MEASUREMENT.BUTTON.MIN_WIDTH};
  opacity: 0.75;
  transition: opacity 0.15s;
  
  &:hover {
    opacity: 1;
  }
  
  &:active {
    opacity: 0.75;
  }
`;

const Icon = styled(FontAwesomeIcon)`
  margin-right: ${Style.SPACING.XS};
`;

function TextButton(props) {
  const icon = props.icon ? <Icon icon={props.icon} /> : null;

  return (
    <Container>
      <StyledTextButton
        className={props.className} // To enable extending styles using Emotion https://emotion.sh/docs/styled#styling-any-component
        onClick={props.onClick}
        tier={props.tier}
      >
        {icon}{props.children}
      </StyledTextButton>
    </Container>
  );
}

TextButton.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  tier: PropTypes.string,
};

TextButton.defaultProps = {
  className: '',
  icon: '',
  tier: TIER.PRIMARY,
};

export default TextButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/TextButton.js